import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainPage from "./pages/MainPage";
import BusRentPage from "./pages/BusRentPage";
import BusDetailPage from "./pages/BusDetailPage";
import MicrobusRentPage from "./pages/MicrobusRentPage";
import MicrobusDetailPage from "./pages/MicrobusDetailPage";
import ContactUsPage from "./pages/ContactUsPage";
import NotFoundPage from "./pages/NotFoundPage";
import { I18nProvider } from "./lib/i18n";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import DemoOverlay from "./components/ui/demo-overlay";
import ScrollToTop from "./components/ui/scroll-to-top";

export function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <NavBar />
          <ScrollToTop />

          <main className="flex-1">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/buses" element={<BusRentPage />} />
              <Route path="/buses/:id" element={<BusDetailPage />} />
              <Route path="/microbuses" element={<MicrobusRentPage />} />
              <Route path="/microbuses/:id" element={<MicrobusDetailPage />} />
              <Route path="/contact" element={<ContactUsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
          <DemoOverlay />
        </div>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
